import * as types from '../actions/actionTypes';

const defaultState = {
  sendingRequest: false,
  requestSuccess: false,
  requestError: '',
  sendingDeposit: false,
  depositSuccess: false,
  depositError: '',
  katWallet: {
    history: [],
    pagination: {},
  },
  kyteWallet: {
    history: [],
    pagination: {},
  },
  loadingKWallet: false,
};

export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);
  switch (action.type) {
    case types.RESET_SUBMIT_REQUEST:
      return {
        ...state,
        sendingRequest: false,
        requestSuccess: false,
        requestError: '',
        sendingDeposit: false,
        depositSuccess: false,
        depositError: '',
      };
    case types.SUBMIT_REQUEST_WITHDRAW:
      return { ...state, ...action.data, sendingRequest: true };
    case types.SUBMIT_REQUEST_WITHDRAW_SUCCESS:
      return { ...state, ...action.data, sendingRequest: false, requestSuccess: true };
    case types.SUBMIT_REQUEST_WITHDRAW_FAILED:
      return {
        ...state,
        sendingRequest: false,
        requestError: action.reason,
        requestSuccess: false,
      };

    case types.SUBMIT_DEPOSIT:
      return { ...state, ...action.data, sendingDeposit: true };
    case types.SUBMIT_DEPOSIT_SUCCESS:
      return { ...state, ...action.data, sendingDeposit: false, depositSuccess: true };
    case types.SUBMIT_DEPOSIT_FAILED:
      return {
        ...state,
        sendingDeposit: false,
        depositSuccess: false,
        depositError: action.reason,
      };

    case types.GET_KWALLET_HISTORY:
      return { ...state, loadingKWallet: true };
    case types.GET_KWALLET_HISTORY_SUCCESS:
      return { ...state, ...action.data, loadingKWallet: false };
    case types.GET_KWALLET_HISTORY_FAILED:
      return { ...state, loadingKWallet: false };
    default:
      return nextState;
  }
};
